module.exports = __webpack_public_path__ + "static/media/Moojiwa Translated by J_Lee_77777.e641ceac.md";